import { FC } from "react";

import TableGoods from "../../../components/table/tunder/TabbleGoods";

import styles from "./goods.module.scss";

const RetailOutlets: FC = () => {
  return (
    <div className={styles.goods}>
      <TableGoods />
    </div>
  );
};

export default RetailOutlets;
